// extracted by mini-css-extract-plugin
export default {"nav":"SimplifiedFeedbackHeader_nav__Wu0e6","pageTitle":"SimplifiedFeedbackHeader_pageTitle__YS625"};